<div class="p-5 pb-0">
  <div class="content">
    @if (nuevoDespacho) {
    <app-nuevo-despacho></app-nuevo-despacho>
    } @else {
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>DESPACHO</mat-card-title>
      </mat-card-header>

      <div class="imprimir-despacho p-5 pt-0 pb-0" style="position: relative; top: -33px">
        <mat-radio-group
          [color]="'primary'"
          class=""
          aria-labelledby="imprimir-despacho"
          class="radio-group"
          [(ngModel)]="tipoDespacho"
          name="rol">
          @for (tipo of tiposDespacho; track tipo) {
          <mat-radio-button class="example-radio-button" [value]="tipo.id">{{
            tipo.descripcion
          }}</mat-radio-button>
          }
        </mat-radio-group>
        <button
          (click)="imprimir()"
          mat-flat-button
          color="primary"
          aria-label="print">
          <mat-icon>print</mat-icon>
          IMPRIMIR
        </button>
      </div>

      <!-- <mat-card-content class="imprimir-container">
        <h1 class="!mb-4">Despacho</h1>
        <div class="imprimir-despacho">
          <mat-radio-group
            [color]="'primary'"
            class=""
            aria-labelledby="imprimir-despacho"
            class="radio-group"
            [(ngModel)]="tipoDespacho"
            name="rol">
            @for (tipo of tiposDespacho; track tipo) {
            <mat-radio-button class="example-radio-button" [value]="tipo.id">{{
              tipo.descripcion
            }}</mat-radio-button>
            }
          </mat-radio-group>
          <button
            (click)="imprimir()"
            mat-flat-button
            color="primary"
            aria-label="print">
            <mat-icon>print</mat-icon>
            IMPRIMIR
          </button>
        </div>
      </mat-card-content> -->
      <mat-card-content
        *ngIf="despachoActual$ | async as despachoActual"
        class="grid gap-2">
        <cdk-accordion
          class="example-accordion"
          *ngIf="despachos$ | async as despachos">
          <cdk-accordion-item
            [style.display]="showDespachoByTipo(item) ? '' : 'none'"
            *ngFor="let item of getFilteredDespachos(despachos); let i = index"
            #accordionItem="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-' + item.id_empresa"
            [attr.aria-expanded]="item.expanded"
            [attr.aria-controls]="'accordion-body-' + item.id_empresa">
            <div
              [ngClass]="{
                'mat-accordion-despacho-gray': i % 2 === 0,
                'mat-accordion-despacho-white': i % 2 !== 0
              }"
              class="example-accordion-item-header"
              (click)="togglePanel(item, item.expanded ?? false)">
              <div class="mat-accordion-counter">
                <ng-container *ngIf="tipoDespacho === 2">
                  {{ item.counterVoBo }}
                </ng-container>

                <ng-container *ngIf="tipoDespacho === 1">
                  {{ item.counterInfo }}
                </ng-container>

                <ng-container *ngIf="tipoDespacho === 0">
                  {{ item.counter }}
                </ng-container>
              </div>
              <div class="mat-accordion-keyboards_arrows">
                {{ item.nombre_empresa }}
                <button>
                  <mat-icon>
                    {{
                      item.expanded
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"
                    }}
                  </mat-icon>
                </button>
              </div>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="
                item.expanded && despachoActual.id_empresa === item.id_empresa
                  ? ''
                  : 'none'
              "
              [attr.id]="'accordion-body-' + item.id_empresa"
              [attr.aria-labelledby]="'accordion-header-' + item.id_empresa">
              <app-informativo-vobo
                *ngIf="allForms.get(item.id_empresa) as despachosforms"
                [tipoDespacho]="tipoDespacho"
                [ngStyle]="{
                  display:
                    item.expanded &&
                    despachoActual.id_empresa === item.id_empresa
                      ? 'block'
                      : 'none'
                }"
                style="pointer-events: auto"
                [despacho]="item"
                [despachos]="despachosforms"></app-informativo-vobo>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>
      </mat-card-content>
    </mat-card>
    }
  </div>

  <button
    (click)="addNuevoDespacho()"
    *ngIf="!nuevoDespacho"
    class="fixed-button"
    mat-fab
    color="warn"
    aria-label="Remove file">
    <mat-icon>add</mat-icon>
  </button>
</div>
